import { piqureWrapper } from 'piqure';

const { provideLazy, inject } = piqureWrapper(globalThis, 'piqure.rule');

export { provideLazy, inject };
